import React, { Component } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ReportsIcon from '@mui/icons-material/Unarchive';
import { Link } from "@reach/router";
import USER_ROLES from '../common/userroles';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

const styles = theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing.unit * 4,
    },
  });

 class Report extends Component {
    state = {
        open: false,
        assignprescription:true,
        reports:true,
        assigneditemsreports:true,
        stockeditemsreports:true,
        pickedUpitemsreports:true,
        transactionsreports:true,
        enrolledPatientsreports:true,
        DeliveryTech: false,
        DeliveryTechReports: true,
        assignedItemDelivery: false,
        outofDelivery: false,
        stockedItemDeliveries: false,
        mydeliveries: false
      };
      handleClick = () => {
        this.setState(state => ({ open: !state.open }));
      };

      componentDidMount(){
        let permissionUser = JSON.parse(sessionStorage.getItem('permissionUser'));
        if( permissionUser === USER_ROLES.DELIVERYTECH){
          this.setState({DeliveryTech: true})
        }
        let permissions  = JSON.parse(sessionStorage.getItem('permissions'));

        if(permissions && permissions.length > 0){
          let permissionObj = {};
      permissions.map((item) => {
        return item.name === "Update Order Status via scanning or manually clicking on orders" ? permissionObj.updateorderstatus = true
          : item.name === "View Delivery Console" ? permissionObj.viewdelivery = true
          :item.name === "Delivered Items" ? permissionObj.deliveredItems = true
          : null
      });
      if (permissionObj.updateorderstatus && permissionObj.viewdelivery) {
        this.setState({DeliveryTech: true})

      }else{
        this.setState({DeliveryTech: false})
      }

      if(permissionObj.deliveredItems){
        this.setState({mydeliveries: true})
      }else{
        this.setState({mydeliveries: false})
      }
          // if(permissions[33].is_allowed === false &&
          //   permissions[34].is_allowed === false){
          //   this.setState({DeliveryTech: false})
          // }
          // if(permissions[38].is_allowed)
          //   {
          //   this.setState({mydeliveries: true})
          // }
          // if(permissions[37].is_allowed)
          //   {
          //   this.setState({stockedItemDeliveries: true})
          // }
          // if(permissions[36].is_allowed)
          //   {
          //   this.setState({outofDelivery: true})
          // }
          // if(permissions[35].is_allowed)
          //   {
          //   this.setState({assignedItemDelivery: true})
          // }
        }else{
          this.setState({DeliveryTech: false})
          this.setState({mydeliveries: false})
        }
      }

    render() {
        const { classes } = this.props;
        return (
            <div id='react-no-print'>
                 <React.Fragment>
                            <ListItem button onClick={this.handleClick}>
                          <ListItemIcon>
                            <ReportsIcon />
                          </ListItemIcon>
                          <ListItemText inset primary="Report" />
                          {this.state.open ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                            {this.state.assignedItemDelivery === true ? (
                        //     <Link to="/home/reports/assigned-items/delivery" style={{textDecoration: 'none'}}>
                        //       <List component="div" disablePadding>
                        //           <ListItem button className={classes.nested}>
                        //           <ListItemText inset primary="Assigned Items" />
                        //           </ListItem>
                        //       </List>
                        //   </Link>
                        // old code
                        <Link to="/home/reports/assigned-items/assigneditems" style={{textDecoration: 'none'}}>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested}>
                        <ListItemText inset primary="Assigned Items" />
                        </ListItem>
                    </List>
                </Link>
                          ):('')}
                        {this.state.outofDelivery === true ? (
                        <Link to="/home/reports/out-of-delivery/delivery" style={{textDecoration: 'none'}}>
                            <List component="div" disablePadding>
                                <ListItem button className={classes.nested}>
                                <ListItemText inset primary="Out for Delivery" />
                                </ListItem>
                            </List>
                        </Link>
                        ):('')}
                        {this.state.stockedItemDeliveries === true ? (
                    //   <Link to="/home/reports/stocked-items/delivery" style={{textDecoration: 'none'}}>
                    //     <List component="div" disablePadding>
                    //         <ListItem button className={classes.nested}>

                    //         <ListItemText inset primary="Stocked Items" />
                    //         </ListItem>
                    //     </List>
                    //   </Link>
                    // old code
                    <Link to="/home/reports/stock-list/StockLists" style={{textDecoration: 'none'}}>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested}>
                        <ListItemText inset primary="Stocked Items" />
                        </ListItem>
                    </List>
                </Link>
                      ):('')}
                        {this.state.mydeliveries === true ? (
                        <Link to="/home/reports/my-delivery/delivery" style={{textDecoration: 'none'}}>
                            <List component="div" disablePadding>
                                <ListItem button className={classes.nested}>
                                <ListItemText inset primary="Delivered Items" />
                                </ListItem>
                            </List>
                        </Link>
                      ) : ('')}
                      </Collapse>
                      </React.Fragment>
            </div>
        )
    }
}
Report.propTypes = {
    classes: PropTypes.object.isRequired,
  };

export default withStyles(styles)(Report);
// export default Report;



// WEBPACK FOOTER //
// ./src/components/leftnav/Report.js